export const MMP_VERSION: string = '<MMP_VERSION>';
